export default {
  name: 'InfoCard',
  props: [
    'card'
  ],
  data() {
    return {
      isExpanded: true
    }
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    }
  },
  mounted() {
    this.isExpanded = this.card.canCollapse
  },
}